import React from 'react';

const FuturisticCard = ({ children, className = '' }) => {
  return (
    <div
      className={`relative overflow-hidden rounded-3xl bg-card/90 backdrop-blur-md border border-white/10 hover:border-primary/40 shadow-lg transition-colors duration-300 ${className}`}
    >
      <div className="relative p-3.5 sm:p-4 h-full flex flex-col z-10">
        {children}
      </div>
    </div>
  );
};

export default FuturisticCard;
